module.exports = "pegasus/assets/global-style.png";